import React from 'react';

import { TbInfoCircle } from 'react-icons/tb';

import Typography from 'components-new/typography/typography';

import Icon from 'components-new/icon/icon';
import { createLocale } from 'locales';

const localize = createLocale('organisationPeriodJobsLocales');

const InfoBox: React.FC = () => {
  return (
    <div className="w-full flex flex-col items-start justify-start rounded-lg border bodrer-solid border-gray-100 shadow-6">
      <Typography
        as="h3"
        variant="heading-4"
        className="w-full h-10 bg-primary-200 mb-3 flex justify-start items-center pl-4 rounded-t-lg"
      >
        <Icon icon={TbInfoCircle} className="mr-2" />
        {localize('explanation')}
      </Typography>
      <Typography
        as="p"
        variant="body-large"
        className="text-gray-800 ml-4 mb-1 mr-2"
      >
        {localize('periodJobsDef')}
      </Typography>
      <div className="ml-5 mr-2">
        <ol className="ml-5 list-decimal">
          <Typography className="my-2" as="li" variant="body-large">
            <b>{localize('info1Title')}</b> {localize('info1')}
          </Typography>
          <Typography
            className="my-2 break-normal"
            as="li"
            variant="body-large"
          >
            <b>{localize('info2Title')}</b> {localize('info2')}
          </Typography>
          <Typography className="my-2" as="li" variant="body-large">
            <b>{localize('info4Title')}</b> {localize('info4')}
          </Typography>
        </ol>
      </div>
      <Typography
        as="p"
        variant="body-large"
        className="text-gray-800 ml-4 mb-3"
      >
        <b>{localize('nb')}</b> {localize('nbContent')}
      </Typography>
    </div>
  );
};

export default InfoBox;
